export default __webpack_public_path__ + "static/media/0011.9b71e6bb.png";